import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons"

export const TimesCircle = (props) => {
  return <FontAwesomeIcon faIcon={faTimesCircle} {...props} />
}
